import React from 'react';

import { usePolicy } from '~/components/PolicyContainer';

import GenericClaimBarField from './GenericClaimBarField';

type SubOrganizationProps = {
  displayName?: string;
};

const SubOrganization = ({ displayName = 'Sub Organization' }: SubOrganizationProps) => {
  const { policy } = usePolicy();
  const subOrganization = policy?.sub_organization;

  return subOrganization ? (
    <GenericClaimBarField title={displayName} content={subOrganization.name} allowWrapping={false} />
  ) : null;
};

export default SubOrganization;
